import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type RateLimitState = {
  /** Whether the user has hit the rate limit */
  isRateLimited: boolean;
  /** ISO timestamp when the rate limit window resets */
  resetsAt: string | null;
  /** Maximum searches allowed per window */
  limit: number;
  /** Human-readable message from the server */
  message: string | null;
  /** Set rate limit state from a 429 response */
  setRateLimited: (info: {
    resetsAt: string;
    limit: number;
    message: string;
  }) => void;
  /** Clear rate limit state (e.g. after the window resets) */
  clearRateLimit: () => void;
};

const useRateLimitStore = create<RateLimitState>()(
  devtools(
    immer((set) => ({
      isRateLimited: false,
      resetsAt: null,
      limit: 25,
      message: null,

      setRateLimited: ({ resetsAt, limit, message }) =>
        set(() => ({
          isRateLimited: true,
          resetsAt,
          limit,
          message,
        })),

      clearRateLimit: () =>
        set(() => ({
          isRateLimited: false,
          resetsAt: null,
          message: null,
        })),
    })),
    { name: 'RateLimitStore' },
  ),
);

export default useRateLimitStore;
